import React from 'react';
import Carousel from '../SlideCarousel';
import Wwa from '../../assets/children/wwa.png'

const AboutUs = ({ id }) => {
  return (
    <section id={id} className='w-full about-us flex flex-col lg:flex-row justify-between items-center py-[64px] px-5 lg:px-[70px] gap-y-10 lg:gap-x-5 mt-10'>
      <div className='lg:w-[70%] w-full'>
        <h1 className='text-[35px] lg:text-[45px] text-[#102343] font-[700]'>
          Who We Are
        </h1>
        <p className='text-[18px] lg:text-[28px] font-[500]  mt-3'>
        Ireti-ola is a home for orphans and vulnerable children in Ibadan, Oyo state, Nigeria. 
        <br></br><br></br>
        We envision a society in which all children without a supportive family structure, have their basic needs met and also have access to shelter, quality education, security and health care.
        </p>
      </div>

      <div className='lg:w-[55%] w-full relative ml-0 lg:ml-4'>
        <img src={Wwa} alt='WWA'/>
      </div>
    </section>
  );
}

export default AboutUs;